import * as firebase from 'firebase/app';
import 'firebase/firestore';

import { CLIENTS } from 'utils/constants/collectionNames';
import { USER_NOT_SIGNED_IN_ERROR_MSG } from 'utils/constants/errors';
import {
  GET_CLIENTS_SUCCEED,
  GET_CLIENTS_ERROR,
  INVITE_CLIENT_SUCCEED,
  INVITE_CLIENT_ERROR,
  GET_CLIENTS_LOADING_STATE
} from './types';

// get client from Firebase
export const getClients = () => async dispatch => {
  try {
    dispatch({ type: GET_CLIENTS_LOADING_STATE });
    let firestore = firebase.firestore();
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        let queryRef = firestore
          .collection(CLIENTS)
          .where('trainer_id', '==', user.uid);
        return queryRef.onSnapshot(querySnapshot => {
          let clients = [];
          querySnapshot.forEach(function(doc) {
            clients.push({
              ...doc.data(),
              id: doc.id
            });
          });
          dispatch({ type: GET_CLIENTS_SUCCEED, payload: clients });
        });
      } else {
        throw new Error(USER_NOT_SIGNED_IN_ERROR_MSG);
      }
    });
  } catch (err) {
    console.log(err);
    dispatch({
      type: GET_CLIENTS_ERROR,
      payload: `error: ${err}`
    });
  }
};

// Add new client to firebase
export const addClient = (values, callback) => async dispatch => {
  try {
    const user = {
      first_name: values.firstName,
      last_name: values.lastName,
      email: values.email,
      phone_number: values.phoneNumber,
      invite: values.inviteByEmail || values.inviteBySMS,
      invite_by_mail: !!values.inviteByEmail.length,
      invite_by_sms: !!values.inviteBySMS.length,
      measurement_unit: values.measurementUnit
    };

    const addNewClient = firebase.functions().httpsCallable('authClientInvite');

    return addNewClient(user)
      .then(() => {
        dispatch({ type: INVITE_CLIENT_SUCCEED });
        callback();
      })
      .catch(err => {
        dispatch({
          type: INVITE_CLIENT_ERROR,
          payload: err
        });
      });
  } catch (err) {
    console.log(err);
    dispatch({
      type: INVITE_CLIENT_ERROR,
      payload: err
    });
  }
};
